import { __assign, __extends } from "tslib";
import { TZ } from '@phensley/timezone';
import { add } from './add';
import { CalendarDate } from './calendar';
import { daysInMonth, initGregorianFields, leapGregorian, monthStart, ymdToJD } from './gregorianmath';
import { unixEpochFromJD } from './math';
var ZEROS = {
    year: 1970,
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millis: 0,
};
/**
 * Construct a date using the rules of the Gregorian calendar.
 *
 * type: gregory
 *
 * @public
 */
var GregorianDate = /** @class */ (function (_super) {
    __extends(GregorianDate, _super);
    function GregorianDate(type, firstDay, minDays) {
        return _super.call(this, type, firstDay, minDays) || this;
    }
    /**
     * Set fields
     *
     * @public
     */
    GregorianDate.prototype.set = function (fields) {
        return this._set(__assign(__assign({}, this.fields()), fields));
    };
    /**
     * Add the fields to this date.
     *
     * @public
     */
    GregorianDate.prototype.add = function (fields) {
        var _a = add(this, fields), jd = _a[0], ms = _a[1];
        return this._new().initFromJD(jd, ms, this.timeZoneId());
    };
    /**
     * Subtract the fields from this date.
     *
     * @public
     */
    GregorianDate.prototype.subtract = function (fields) {
        return this.add(this._negatePeriod(fields));
    };
    /**
     * Change the timezone, returning a new date.
     *
     * @public
     */
    GregorianDate.prototype.withZone = function (zoneId) {
        return this._new().initFromUnixEpoch(this.unixEpoch(), zoneId);
    };
    /**
     * String representation of the date and time.
     *
     * @public
     */
    GregorianDate.prototype.toString = function () {
        return this._toString('Gregorian');
    };
    /**
     * Construct a new date from the given fields.
     *
     * @public
     */
    GregorianDate.fromFields = function (fields, firstDay, minDays) {
        if (firstDay === void 0) { firstDay = 1; }
        if (minDays === void 0) { minDays = 1; }
        return new GregorianDate('gregory', firstDay, minDays)._set(__assign(__assign({}, ZEROS), fields));
    };
    /**
     * Construct a new date from the given UNIX epoch.
     *
     * @public
     */
    GregorianDate.fromUnixEpoch = function (epoch, zoneId, firstDay, minDays) {
        if (firstDay === void 0) { firstDay = 1; }
        if (minDays === void 0) { minDays = 1; }
        return new GregorianDate('gregory', firstDay, minDays).initFromUnixEpoch(epoch, zoneId);
    };
    GregorianDate.prototype._new = function () {
        return new GregorianDate('gregory', this._firstDay, this._minDays);
    };
    GregorianDate.prototype.initFromUnixEpoch = function (epoch, zoneId) {
        _super.prototype.initFromUnixEpoch.call(this, epoch, zoneId);
        initGregorianFields(this._fields);
        return this;
    };
    GregorianDate.prototype.initFromJD = function (jd, msDay, zoneId) {
        _super.prototype.initFromJD.call(this, jd, msDay, zoneId);
        initGregorianFields(this._fields);
        return this;
    };
    // TODO: reorganize calendar-specific methods
    GregorianDate.prototype.daysInMonth = function (y, m) {
        return daysInMonth(y, m);
    };
    // TODO: reorganize calendar-specific methods
    GregorianDate.prototype.daysInYear = function (y) {
        return leapGregorian(y) ? 366 : 365;
    };
    GregorianDate.prototype.monthCount = function () {
        return 12;
    };
    GregorianDate.prototype.monthStart = function (eyear, month, _useMonth) {
        return monthStart(eyear, month, _useMonth);
    };
    GregorianDate.prototype._set = function (f) {
        var jd = ymdToJD(f.year, f.month, f.day, this.monthCount());
        var ms = this._timeToMs(f);
        var epoch = unixEpochFromJD(jd, ms);
        var zoneId = f.zoneId || this.timeZoneId();
        // Find UTC epoch for wall clock time in the requested timezone
        var r = TZ.fromWall(zoneId, epoch);
        return this._new().initFromUnixEpoch(r ? r[0] : epoch, zoneId);
    };
    GregorianDate._init = (function () {
        CalendarDate._gregorian = function (d, utc, fd, md) {
            return GregorianDate.fromUnixEpoch(d.unixEpoch(), utc ? 'Etc/UTC' : d.timeZoneId(), fd, md);
        };
    })();
    return GregorianDate;
}(CalendarDate));
export { GregorianDate };
//# sourceMappingURL=gregorian.js.map